export default class ContentAndIcons {
    constructor() {
        
    }
}

new ContentAndIcons();


// WEBPACK FOOTER //
// ../views/modules/content-and-icons/assets/js/content-and-icons.js